import { BenefitModeEnum } from './benefit-mode-enum.generated';

const x: { [index: string]: string } = {};
x[BenefitModeEnum.NotApplicable] = 'Not Applicable';
x[BenefitModeEnum.Monthly] = 'Monthly';
x[BenefitModeEnum.Annually] = 'Annually';
x[BenefitModeEnum.Weekly] = 'Weekly';
x[BenefitModeEnum.Percentage] = 'Percentage';
x[BenefitModeEnum.AnnualLumpSum] = 'Annual - Lump Sum';
export const BenefitModeEnumDescriptions: { [indexer: string]: string } = x;
